<ion-header
  class="ion-no-border"
  [ngClass]="
    platformService?.platformType === platformService.platformEnum.tablet
      ? 'ion-header-modal-tablet'
      : 'ion-header-modal-mobile'
  "
>
  <ion-toolbar>
    <ion-label data-cy="modal-title-text">
      {{ title }}
      <div
        class="page-name"
        data-cy="modal-subtitle-text"
        [innerHTML]="subtitle"
      ></div>
    </ion-label>
    <div class="horizontal-divider"></div>
  </ion-toolbar>
</ion-header>
<ion-content
  [ngClass]="
    platformService?.platformType === platformService.platformEnum.tablet
      ? 'ion-content-modal-tablet'
      : 'ion-content-modal-mobile'
  "
>
  <ion-grid>
    <section>
      <ion-row>
        <ion-col>
          <p class="main-text" data-cy="modal-content-text">
            {{ text }}
          </p>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="close-button-container">
          <ion-button
            class="usf-fill-green-mobile-modal-button"
            (click)="closeModal()"
          >
            {{ 'i18n.common.close' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </section>
  </ion-grid>
</ion-content>
